module.exports = __webpack_public_path__ + "assets/img/f43f24597a300baeb72981e74d72e348.svg";